<template>
  <div>
    <div class="border-bottom border-primary" v-for="log in logs" :key="log.id">
      <pre>
        <code>
        {{log | stringifyJson}}
      </code>

      </pre>
    </div>
    <div class="d-flex justify-content-center w-100" v-if="isCallingLogs">
      <spinner />
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
import _paginationHandler from '@/components/Commons/_mixins/_paginationHandlerMixin'
export default {
  name: 'OfficeLogPanel',
  mixins: [_paginationHandler],
  components: { Spinner },
  props: {
    entity: {
      type: String,
      required: true
    }
  },
  computed: {
    logs () {
      return this.$store.getters['LogsStore/logs']
    },
    currentPage () {
      return this.$store.getters['LogsStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['LogsStore/lastPage']
    },
    isCallingLogs () {
      return this.$store.getters['LogsStore/isCallingLogs']
    }
  },
  methods: {
    nextPage () {
      this.$store.dispatch('LogsStore/nextLogsPage', this.entity)
    }
  }

}
</script>
